import { Col } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import Theme from "../../../../../../styles/Theme/Theme";
import { groupBy } from "../../../../../../utils/hooks/gourpBy";
import { isEmpty } from "../../../../../../utils/hooks/isEmpty";
import { Widget } from "../../../../Atomics/Widget";

export const LeftIncidentsWidgetsMultipleClassComponent = ({ items }) => {
    const { t } = useTranslation();

    return (
        <Col span={24}>
            <Widget
                data={{
                    background: "white",
                    title: t("filed.Number of Incidents By Class"),
                    icon: null,
                    activeShadow: true,
                    margin: "0 0 10px 10px",
                    charts: [
                        {
                            chartType: "horizontalMultipleStackedBarsChart",
                            // height: "320px",
                            data: items && !isEmpty(items) ? getStackedIncidentsByClass(items, t) : null
                        },
                    ],
                }}
            />
        </Col>
    );
};

const getByPriority = (items, t) => {
    const priorities = ["1 - High", "2 - Medium High", "3 - Medium", "4 - Medium Low", "5 - Low"];
    const colors = [Theme.color['critical-base'], Theme.color['high-base'], Theme.color['medium-base'], Theme.color['low-base'], Theme.color['info-base']];
    const result = [];
    priorities.forEach((priority, index) => {
        const value = items.filter(item => item.priority === priority).length;
        if (value > 0) {
            result.push({ name: t(priority.split(' - ')[1]), value: value, color: colors[index] });
        }
    });

    return result;
};

const getStackedIncidentsByClass = (items, t) => {
    const groupedByClass = groupBy(items, 'class');
    const result = [];

    Object.entries(groupedByClass).forEach(([key, value]) => {
        const data = getByPriority(value, t);
        if (data.length > 0) {
            result.push({
                name: t(key),
                data: data,
                icon: key,
            });
        }
    });

    return {
        data: result,
        linesForColumn: 1,
        scrollY: true,
    };
};